import { LabelChip, SxProps, colorOrToken, tokens } from '@cast/design-system';

type FeatureType = 'premium' | 'free' | 'early-access' | 'new' | 'trial';

const earlyAccessStyle = {
  backgroundColor: colorOrToken(
    'green.100',
    tokens.theme.bg.categorical.greenSubtle
  ),
  // No suitable semantic token found: green.600 has no categorical foreground
  // equivalent that matches this shade (categorical.onGreenSubtle is green.700);
  // preserving the original color via primitive.
  color: colorOrToken('green.600', tokens.primitives.colors.green[600]),
};

const dataMap: Record<
  FeatureType,
  { backgroundColor: string; color: string; label: string; testId: string }
> = {
  premium: {
    backgroundColor: colorOrToken(
      'blue.400',
      tokens.theme.bg.categorical.blueStrong
    ),
    color: colorOrToken('#fff', tokens.theme.fg.categorical.onBlueStrong),
    label: 'Premium',
    testId: 'premium-chip',
  },
  free: {
    // No suitable semantic token found: green.600 has no categorical equivalent
    // (categorical.greenStrong resolves to green.400); the exact match
    // (action.secondaryHover) carries interaction context that doesn't apply to a static badge.
    backgroundColor: colorOrToken(
      'green.600',
      tokens.primitives.colors.green[600]
    ),
    color: colorOrToken('#fff', tokens.theme.fg.categorical.onGreenStrong),
    label: 'Free',
    testId: 'free-chip',
  },
  'early-access': {
    ...earlyAccessStyle,
    label: 'Early Access',
    testId: 'early-access-chip',
  },
  new: {
    ...earlyAccessStyle,
    label: 'New',
    testId: 'new-chip',
  },
  trial: {
    backgroundColor: colorOrToken(
      'blue.400',
      tokens.theme.bg.categorical.blueStrong
    ),
    color: colorOrToken('#fff', tokens.theme.fg.categorical.onBlueStrong),
    label: '30-day free trial',
    testId: 'free-trial-chip',
  },
};

type FeatureLabelProps = {
  type?: FeatureType;
  sx?: SxProps;
};
const FeatureLabel = ({ type = 'free', sx }: FeatureLabelProps) => {
  const { backgroundColor, color, label, testId } = dataMap[type];

  return (
    <LabelChip
      size="2xs"
      sx={{
        ...sx,
        color,
        backgroundColor,
        flexShrink: 0,
      }}
      testId={testId}
    >
      {label}
    </LabelChip>
  );
};

export default FeatureLabel;
